module.exports = __webpack_public_path__ + "static/media/view patient details.8ab4931e.svg";